export function formatOperationalDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const timeZone = 'America/Fortaleza';
  return `${new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeZone }).format(date)} às ${new Intl.DateTimeFormat('pt-BR', { timeStyle: 'short', timeZone }).format(date)}`;
}
